// F1 Data Page Example
import React from 'react';
import F1Dashboard from '../../components/f1/F1Dashboard';
import { useSiblingData } from '../../hooks/useSiblingData';

const F1DataPage = () => {
  // Example of loading specific files from sibling folder
  const { data: specificData, loading: specificLoading } = useSiblingData([
    'drivers.csv',
    'races.csv'
  ]);

  return (
    <div className="min-h-screen theme-bg-secondary">
      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold theme-primary">F1 Racing Data</h1>
          <p className="theme-secondary mt-2">
            Real-time Formula 1 statistics and racing analytics
          </p>
        </div>

        {/* Full Dashboard */}
        <F1Dashboard />

        {/* Alternative: Specific Data Loading */}
        {specificData && !specificLoading && (
          <div className="mt-12 space-y-8">
            <h2 className="text-2xl font-bold theme-primary mb-6">Specific Data Example</h2>
            
            <div className="card">
              <h3 className="text-lg font-semibold mb-4">Loaded Files</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {Object.entries(specificData).map(([fileName, fileData]) => (
                  <div key={fileName} className="border theme-border-secondary rounded-lg p-4">
                    <h4 className="font-semibold theme-primary capitalize">{fileName}</h4>
                    <p className="text-sm theme-secondary mt-1">{fileData?.length || 0} records</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default F1DataPage;
